import { StyleSheet } from 'react-native';

export const characterStageStyles = StyleSheet.create({
  root: {
    position: 'relative',
  },
  layerStack: {
    ...StyleSheet.absoluteFillObject,
  },
});
